var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path0, _path1, _path10, _path11, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlreadyInBasketError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 302,
    viewBox: "0 0 372 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.337 248.398L201.43 237.563L125.822 265.111L66.8752 102.591C61.8193 88.7599 48.4903 80 34.4718 80H5.74529C2.52793 80 0 82.5358 0 85.7631C0 88.9904 2.52793 91.5262 5.74529 91.5262H34.4718C43.894 91.5262 52.6269 97.2893 56.0741 106.626L118.928 279.98L205.337 248.398Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.632 132.241L90.4531 167.719L125.821 265.199L223 229.722L187.632 132.241Z",
    fill: "#86C2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.957 153.306L136.507 171.518L143.861 163.219L154.777 164.948L148.112 146.736L129.957 153.306Z",
    fill: "#F3F3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.597 301.417C132.093 301.417 142.224 291.287 142.224 278.791C142.224 266.294 132.093 256.164 119.597 256.164C107.101 256.164 96.9707 266.294 96.9707 278.791C96.9707 291.287 107.101 301.417 119.597 301.417Z",
    fill: "#808080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.597 288.486C124.953 288.486 129.295 284.144 129.295 278.789C129.295 273.433 124.953 269.092 119.597 269.092C114.242 269.092 109.9 273.433 109.9 278.789C109.9 284.144 114.242 288.486 119.597 288.486Z",
    fill: "#F3F3F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M371.889 193.621L312.764 173.029L292.283 231.836L351.408 252.428L371.889 193.621Z",
    fill: "#FF849A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M336.809 181.404L332.986 192.382L339.551 191.298L344.022 196.225L347.845 185.248L336.809 181.404Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M272.395 159.25L252.003 217.801L292.707 231.977L301.9 205.58L313.098 173.426L272.395 159.25Z",
    fill: "url(#paint0_linear_21500_387329)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M272.395 159.25L252.003 217.801L292.707 231.977L301.9 205.58L313.098 173.426L272.395 159.25Z",
    fill: "url(#paint1_linear_21500_387329)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 295.713,
    y: 171.934,
    width: 3.97861,
    height: 26.1925,
    rx: 1.9893,
    transform: "rotate(109.202 295.713 171.934)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 285.553,
    y: 178.928,
    width: 3.97861,
    height: 18.8984,
    rx: 1.9893,
    transform: "rotate(109.202 285.553 178.928)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 293.553,
    y: 192.248,
    width: 3.97861,
    height: 30.8342,
    rx: 1.9893,
    transform: "rotate(109.202 293.553 192.248)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 275.566,
    y: 196.516,
    width: 3.97861,
    height: 15.2513,
    rx: 1.9893,
    transform: "rotate(109.202 275.566 196.516)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 284.506,
    y: 210.162,
    width: 3.97861,
    height: 28.1818,
    rx: 1.9893,
    transform: "rotate(109.202 284.506 210.162)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 276.85,
    y: 218.027,
    width: 3.97861,
    height: 23.5401,
    rx: 1.9893,
    transform: "rotate(109.202 276.85 218.027)",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8387 3.00113L43.0371 44.5879L84.3996 91.1371L131.201 49.5504L89.8387 3.00113Z",
    fill: "#FF849A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0703 27.6758L69.7913 36.365L72.0454 30.1043L78.5276 28.6021L70.8066 19.9129L62.0703 27.6758Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.322 123.762L159.669 82.5793L131.039 50.3597L110.145 68.9259L84.6928 91.5422L113.322 123.762Z",
    fill: "url(#paint2_linear_21500_387329)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.322 123.762L159.669 82.5793L131.039 50.3597L110.145 68.9259L84.6928 91.5422L113.322 123.762Z",
    fill: "url(#paint3_linear_21500_387329)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 99.1484,
    y: 101.32,
    width: 3.97861,
    height: 26.1925,
    rx: 1.9893,
    transform: "rotate(-41.6235 99.1484 101.32)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 111.428,
    y: 100.166,
    width: 3.97861,
    height: 18.8984,
    rx: 1.9893,
    transform: "rotate(-41.6235 111.428 100.166)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 110.936,
    y: 84.6367,
    width: 3.97861,
    height: 30.8342,
    rx: 1.9893,
    transform: "rotate(-41.6235 110.936 84.6367)",
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 128.721,
    y: 89.6777,
    width: 3.97861,
    height: 15.2513,
    rx: 1.9893,
    transform: "rotate(-41.6235 128.721 89.6777)",
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 127.568,
    y: 73.4043,
    width: 3.97861,
    height: 28.1818,
    rx: 1.9893,
    transform: "rotate(-41.6235 127.568 73.4043)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 138.086,
    y: 70.2676,
    width: 3.97861,
    height: 23.5401,
    rx: 1.9893,
    transform: "rotate(-41.6235 138.086 70.2676)",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M232.1 72.4992V49.1992H255.5L232.1 72.4992Z",
    fill: "#FF849A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M314.1 56.8H222C218.7 56.8 216 54.1 216 50.8V6C216 2.7 218.7 0 222 0H314.1C317.4 0 320.1 2.7 320.1 6V50.8C320.1 54.1 317.4 56.8 314.1 56.8Z",
    fill: "#FF849A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M264.141 12H272.859L271.406 33.3008H265.594L264.141 12ZM268.5 45C267.219 45 266.141 44.596 265.266 43.7881C264.422 42.9492 264 41.9393 264 40.7585C264 39.5777 264.422 38.5989 265.266 37.822C266.109 37.0141 267.188 36.6102 268.5 36.6102C269.812 36.6102 270.891 37.0141 271.734 37.822C272.578 38.5989 273 39.5777 273 40.7585C273 41.9393 272.562 42.9492 271.688 43.7881C270.844 44.596 269.781 45 268.5 45Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21500_387329",
    x1: 261.155,
    y1: 198.26,
    x2: 296.657,
    y2: 212.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4449,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21500_387329",
    x1: 261.155,
    y1: 198.26,
    x2: 296.657,
    y2: 212.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4449,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21500_387329",
    x1: 142.152,
    y1: 95.1794,
    x2: 117.992,
    y2: 65.6251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4449,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21500_387329",
    x1: 142.152,
    y1: 95.1794,
    x2: 117.992,
    y2: 65.6251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4449,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlreadyInBasketError);
export default __webpack_public_path__ + "static/media/AlreadyInBasketError.fa132f3d.svg";
export { ForwardRef as ReactComponent };